import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';
import { AuthenticationService } from '../authentication.service';
import { ROUTES } from '../enums/routes';
import { BehaviorSubject, Observable } from 'rxjs';
import { RootFacade } from 'src/app/abstraction/root.facade';
import { ExperienceI18nService } from '../experience/experience-i18n.service';

@Injectable({
    providedIn: 'root',
})
export class HttpErrorHandlerService {
    private _outOfService = new BehaviorSubject<boolean>(false);
    constructor(
        private rootFacade: RootFacade,
        private authService: AuthenticationService,
        private router: Router,
        private experienceI18n: ExperienceI18nService,
    ) { }

    handleError(httpErrorResponse: HttpErrorResponse) {
        let message: string;
        // aca obtengo si es /login
        // console.log(httpErrorResponse);

        switch (httpErrorResponse.status) {

            case 400: // Bad Request (Business Error)
                message = this.extractNestedMessage(httpErrorResponse.error.error.message);
                // Show the message in the component from where the call came
                break;
            case 401: // Unauthorized
                this.authService.removeCurrentUser();
                this.rootFacade.cleanStore();
                message = this.messageForUnauthorized(httpErrorResponse);
                this.router.navigate([ROUTES.LOGIN]);
                break;
            case 403: // Forbidden
                message = !!httpErrorResponse.error.error
                    ? httpErrorResponse.error.error.message
                    : this.experienceI18n.translate('core.services.http-error-handler.access-forbidden', undefined, 'Acceso prohibido');
                break;
            case 404: // Not Found
                message = !!httpErrorResponse.error.error.message ? httpErrorResponse.error.error.message?.message : this.experienceI18n.translate('core.services.http-error-handler.contact-admin', undefined, 'Póngase en contacto con su administrador ya que ocurrió un error');
                break;
            case 409: // Conflict
                message = httpErrorResponse.error.error.message;
                // Show the message in the component from where the call came
                break;
            case 418:
                // Nothing to do
                // In this case set message with swal inside affected component
                break;
            case 422: // Unprocessable Entity (parameters invalid)
                // Check how does the response comes
                message = httpErrorResponse.error.error.message;
                // Show the response in the appropiate form fields
                break;
            case 500: // Internal Server Error
                message = this.experienceI18n.translate('core.services.http-error-handler.contact-admin', undefined, 'Póngase en contacto con su administrador ya que ocurrió un error');
                // Show a message telling that the server had a problem
                // TO DO
                // message = 'Error en el servidor, reinténtelo más tarde';
                // Redirect the user to HOME
                // router.navigate([Routes.LOGIN]);
                break;
            case 504:
                // if (this.router.url !== '/login') {
                //    this.authService.logout().subscribe(
                //       () => {
                //          this.router.navigate([ROUTES.LOGIN]);
                //       },
                //       (err) => {
                //          this.router.navigate([ROUTES.LOGIN]);
                //       },
                //    );
                // }
                // this.setOutOfService(true);
                message = this.experienceI18n.translate('core.services.http-error-handler.processing-request', undefined, 'Estamos procesando su solicitud. Esto puede tomar unos minutos. Por favor, espere y vuelva a ingresar más tarde.');
                break;
            // TODO: Buscar que error va a tirar, es 0?
            default:

                // Any other possible error status
                message = this.experienceI18n.translate('core.services.http-error-handler.occurred', undefined, 'Ha ocurrido un error');
                break;
        }
        return message;
    }

    isOutOfService(): Observable<boolean> {
        return this._outOfService.asObservable();
    }

    setOutOfService(value: boolean) {
        this._outOfService.next(value);
    }

    private extractNestedMessage(message: string): string {
        return message || this.experienceI18n.translate('core.services.http-error-handler.request-error', undefined, 'Error en la solicitud');
    }

    /** Safe for empty or non-JSON 401 bodies (e.g. gateway / refresh). */
    private messageForUnauthorized(res: HttpErrorResponse): string {
        const body = res.error as { error?: { message?: string; error?: { message?: string } } } | null;
        let backendMsg: string | undefined;
        if (body != null && typeof body === 'object' && body.error != null && typeof body.error === 'object') {
            const inner = body.error;
            if (typeof inner.message === 'string') {
                backendMsg = inner.message;
            } else if (inner.error != null && typeof inner.error.message === 'string') {
                backendMsg = inner.error.message;
            }
        }
        if (typeof backendMsg === 'string' && (backendMsg.includes('Su ses') || backendMsg.includes('Token'))) {
            return this.experienceI18n.translate('core.services.http-error-handler.session-expired', undefined, 'Su sesión ha expirado');
        }
        if (typeof backendMsg === 'string' && backendMsg.length > 0) {
            return backendMsg;
        }
        return this.experienceI18n.translate('core.services.http-error-handler.session-expired', undefined, 'Su sesión ha expirado');
    }
}
